import { render, staticRenderFns } from "./AutoStartConfig.vue?vue&type=template&id=bc9bc3fa&scoped=true"
import script from "./AutoStartConfig.vue?vue&type=script&lang=ts"
export * from "./AutoStartConfig.vue?vue&type=script&lang=ts"
import style0 from "./AutoStartConfig.vue?vue&type=style&index=0&id=bc9bc3fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9bc3fa",
  null
  
)

export default component.exports